<template>
  <div class="login_page">
    <v-container class="fluid">
      <v-row no-gutters>
        <v-col xs="12" sm="6" md="6" lg="4" xl="4">
          <v-card elevation="8">
            <v-stepper v-model="stepLogin">
              <v-stepper-items>

                <!-- Login -->
                <v-stepper-content step="1">
                  <v-form ref="add_form" @submit.prevent="NextStep">
                    <div class="mb-4" style="margin-bottom: 15px;">
                      <h4 class="card-title-text mb-1 pt-2">Welcome to Pharmacare</h4>
                      <p class="card-sub-title-text mb-4">เข้าสู่ระบบจัดการเอรีนคลินิก</p>
                    </div>
                    <v-form-group>
                      <label>เบอร์โทรเข้าสู่ระบบ <span class="required--text">*</span></label>
                      <v-text-field type="text" label="เบอร์โทรเข้าสู่ระบบ" prepend-inner-icon="mdi-account"
                        v-model="telephone" color="#D6BFAF" @keypress="isNumber($event, telephone)"
                        :rules="[v => !!v || 'กรุณากรอกข้อมูล']"
                        single-line outlined dense required></v-text-field>
                    </v-form-group>
                    <v-form-group>
                      <label>รหัสผ่าน <span class="required--text">*</span></label>
                      <v-text-field label="รหัสผ่าน" prepend-inner-icon="mdi-lock" v-model="password" color="#D6BFAF"
                        hide-details="auto" :rules="[v => !!v || 'กรุณากรอกข้อมูล']"
                        :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'" :type="show ? 'text' : 'password'"
                        @click:append="show = !show" single-line outlined dense required></v-text-field>
                    </v-form-group>
                    <v-checkbox v-model="selected" color="#D6BFAF" label="จำรหัสผ่าน" />
                    <div class="btn_custom">
                      <v-btn type="submit" elevation="4" large
                        class="btn_next white--text mr-3 text_color">
                        ถัดไป
                      </v-btn>
                    </div>
                  </v-form>
                </v-stepper-content>
                <!-- Login -->

                <!-- เลือกสาขา (สำหรับ employee) -->
                <v-stepper-content step="2">
                  <div class="mb-4" style="margin-bottom: 15px;">
                    <h4 class="card-title-text mb-1 pt-2">Welcome to Pharmacare</h4>
                    <p class="card-sub-title-text mb-4">เลือกสาขาเพื่อเข้าใช้งาน</p>
                  </div>
                  <v-list>
                    <v-list-item-group color="#D6BFAF">
                      <v-list-item v-for="(item, i) in branch" :key="i" @click="stepper_active(item.id)" class="my-2">

                        <v-icon color="#A3802E">mdi-home</v-icon>

                        <v-list-item-content>
                          <div class="choice_branch">
                            <v-list-item-title class="text_style_color">{{item.branch_name}}</v-list-item-title>
                            <div class="logo_branch">
                              <v-img v-if="item.status === true" src="@/assets/arin_assets/check_active.png" />
                            </div>
                          </div>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>
                  <div class="btn_custom">
                    <v-btn v-if="branch_check_id != null" type="button" elevation="4" large @click="LogIn"
                      class="btn_next white--text mr-3 text_color">
                      ยืนยัน
                    </v-btn>
                    <v-btn v-else type="button" elevation="4"
                      class="btn_next_close white--text mr-3 text_color">
                      เลือกสาขา
                    </v-btn>
                  </div>
                </v-stepper-content>
                <!-- เลือกสาขา (สำหรับ employee) -->

              </v-stepper-items>
            </v-stepper>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { isTelephone, taxNumber, validateEmail, onPaste } from "@/js/handler";
import {HTTP_ARIN} from "@/axios_arin";
import Swal from "sweetalert2";
import login from '@/api_arin/login/login.js'
// import { watch } from 'vue';

export default {
  name: "ArinLogin",
  data() {
    return {
      show: false,
      telephone: '',
      password: '',
      overlay: false,
      alert_error: false,
      selected: false,
      stepLogin: 1,
      selectedItem: 0,
      branch_check_id: null,
      branch_id: null,
      branch_name: null,
      branch: [],
      userDetail: [],
    }
    
  },
  methods: {
    async checkSpace(value) {
      this.telephone = await value.replace(/\s/g, '')
      console.log();(this.telephone)
    },

    // ฟังค์ชั่น เลือกสาขาแล้วขึ้น check ถูก
    stepper_active(id) {
      this.branch.forEach((data) => {
        if (data.id === id) {
          if (data.status !== true) {
            data.status = true
            this.branch_check_id = data.id
          } else {
            data.status = false
            this.branch_check_id = null
          }
        } else {
            data.status = false
        }
      })
    },

     // ฟังค์ชั่น login ของพนักงาน
    async LogIn() {
      let send_data = {
        telephone: this.telephone,
        password: this.password
      }
      try {

          this.overlay = true
          const response = await login.login(send_data)

          if (response.data.successful === true) {

              const config = { headers: { "Authorization": `Bearer ${response.data.access_token}` } }
              HTTP_ARIN.get('/profile/detail', config).then((res) => {
                if (res.data.successful == true) {
                  
                  // status_permission สถานะ 0 = Admin / 1 = จะเป็นเช็คตาราง employee ในฟิลฟ์ claim_status ต่อดังนี้ 0 = Admin / 1 = Employee
                  const userData = {
                    access_token: response.data.access_token,
                    user_data: res.data.ProfileDetail_emp,
                    status_permission: res.data.ProfileDetail_emp_type,
                  }
                  
                  this.$store.commit('store_arin/login_success', userData)
                  this.checkLogIn();
                  // console.log(res.data);
                }else{
                  this.overlay = false
                  Swal.fire({
                    title: 'ไม่พบข้อมูล',
                    text: 'ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง กรุณาตรวจสอบใหม่อีกครั้ง',
                    icon: 'warning',
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonText: `ตกลง`,
                    denyButtonText: `ยกเลิก`,
                  }).then((result) => {
                    if (result.isConfirmed) {
                      this.confirmError();
                    }
                  });
                }
              })
              // this.checkLogin()
          }

          if(response.data.successful === false && response.data.brancList){
              const config = { headers: { "Authorization": `Bearer ${response.data.access_token}` } }
              HTTP_ARIN.get('/auth/login/emp/'+this.branch_check_id, config).then((res) => {
                if (res.data.successful == true) {
                      const config = { headers: { "Authorization": `Bearer ${res.data.access_token}` } }
                      HTTP_ARIN.get('/profile/detail', config).then((detail) => {
                          if (detail.data.successful == true) {
                            // status_permission สถานะ 0 = Admin / 1 = จะเป็นเช็คตาราง employee ในฟิลฟ์ claim_status ต่อดังนี้ 0 = Admin / 1 = Employee
                            const userData = {
                                access_token: res.data.access_token,
                                user_data: detail.data.ProfileDetail_emp,
                                status_permission: detail.data.ProfileDetail_emp_type,
                              }
                            // console.log(userData);
                            this.$store.commit('store_arin/login_success', userData)
                            this.checkLogIn();
                          
                          }
                        })
                }
                })
          }

      } catch (error) {
        console.error('Login error:', error);
        this.overlay = false;
        
        // ตรวจสอบว่า error มี response หรือไม่
        if (error.response) {
          const status = error.response.status;
          const message = error.response.data?.message || 'เกิดข้อผิดพลาด กรุณาตรวจสอบใหม่อีกครั้ง';
          
          if (status === 401 || status === 403) {
            Swal.fire({
              title: 'ไม่สามารถเข้าสู่ระบบได้',
              text: 'ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง กรุณาตรวจสอบใหม่อีกครั้ง',
              icon: 'warning',
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: `ตกลง`,
            }).then((result) => {
              if (result.isConfirmed) {
                this.confirmError();
              }
            });
          } else if (status === 500) {
            Swal.fire({
              title: 'เกิดข้อผิดพลาด',
              text: 'เกิดข้อผิดพลาดจากเซิร์ฟเวอร์ กรุณาตรวจสอบใหม่อีกครั้ง',
              icon: 'error',
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: `ตกลง`,
            }).then((result) => {
              if (result.isConfirmed) {
                this.confirmError();
              }
            });
          } else {
            Swal.fire({
              title: 'เกิดข้อผิดพลาด',
              text: message,
              icon: 'warning',
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: `ตกลง`,
            }).then((result) => {
              if (result.isConfirmed) {
                this.confirmError();
              }
            });
          }
        } else if (error.request) {
          // Network error หรือ timeout
          Swal.fire({
            title: 'ไม่สามารถเชื่อมต่อได้',
            text: 'ไม่สามารถเชื่อมต่อกับเซิร์ฟเวอร์ได้ กรุณาตรวจสอบการเชื่อมต่ออินเทอร์เน็ต',
            icon: 'error',
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: `ตกลง`,
          }).then((result) => {
            if (result.isConfirmed) {
              this.confirmError();
            }
          });
        } else {
          // Error อื่นๆ
          Swal.fire({
            title: 'เกิดข้อผิดพลาด',
            text: 'เกิดข้อผิดพลาดที่ไม่ทราบสาเหตุ กรุณาตรวจสอบใหม่อีกครั้ง',
            icon: 'error',
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: `ตกลง`,
          }).then((result) => {
            if (result.isConfirmed) {
              this.confirmError();
            }
          });
        }
      }
    },

    // ฟังค์ชั่น login ของเจ้าของร้าน
    async NextStep() {
      if (this.$refs.add_form.validate()) {
        let send_data = {
          telephone: this.telephone,
          password: this.password
        }

        try {

          this.overlay = true
          const response = await login.login(send_data)
          // console.log(response.data);

          if (response.data.message == 'tel_fail') {
            this.overlay = false
            Swal.fire({
              title: 'เบอร์โทรไม่ถูกต้อง',
              text: 'เบอร์โทรไม่ถูกต้อง กรุณาตรวจสอบใหม่อีกครั้ง',
              icon: 'warning',
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: `ตกลง`,
              denyButtonText: `ยกเลิก`,
            }).then((result) => {
              if (result.isConfirmed) {
                this.confirmError();
              }
            });
            
          }else if (response.data.message == 'password_fail'){
            
            this.overlay = false
            Swal.fire({
              title: 'รหัสผ่านไม่ถูกต้อง',
              text: 'รหัสผ่านไม่ถูกต้อง กรุณาตรวจสอบใหม่อีกครั้ง',
              icon: 'warning',
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: `ตกลง`,
              denyButtonText: `ยกเลิก`,
            }).then((result) => {
              if (result.isConfirmed) {
                this.confirmError();
              }
            });

          }

          if (response.data.customers === 'successful_Cus') {

              const config = { headers: { "Authorization": `Bearer ${response.data.access_token}` } }
              HTTP_ARIN.get('/profile/detail', config).then((res) => {
                if (res.data.successful == true) {
                  
                  // status_permission สถานะ 0 = Admin / 1 = จะเป็นเช็คตาราง employee ในฟิลฟ์ claim_status ต่อดังนี้ 0 = Admin / 1 = Employee
                  const userData = {
                    access_token: response.data.access_token,
                    user_data: res.data.ProfileDetail,
                    status_permission: res.data.ProfileDetail_type,
                  }
                  // console.log(userData);
                  this.$store.commit('store_arin/login_success', userData)
                  this.checkLogIn();
                 
                }else{
                  this.overlay = false
                  Swal.fire({
                    title: 'ไม่พบข้อมูล',
                    text: 'ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง กรุณาตรวจสอบใหม่อีกครั้ง',
                    icon: 'warning',
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonText: `ตกลง`,
                    denyButtonText: `ยกเลิก`,
                  }).then((result) => {
                    if (result.isConfirmed) {
                      this.confirmError();
                    }
                  });
                }
              })
              // this.checkLogin()
          }
          if(response.data.successful === false){
              this.stepLogin = 2
             this.branch = response.data.brancList.map((obj) => {
            return { 
              id: obj.id,
              branch_name: obj.store_name,
              status: false
            }
          });
          }
          
       
            
          

        } catch (error) {
          console.error('NextStep error:', error);
          this.overlay = false;
          
          // ตรวจสอบว่า error มี response หรือไม่
          if (error.response) {
            const status = error.response.status;
            const message = error.response.data?.message || 'เกิดข้อผิดพลาด กรุณาตรวจสอบใหม่อีกครั้ง';
            
            if (status === 401 || status === 403) {
              Swal.fire({
                title: 'ไม่สามารถเข้าสู่ระบบได้',
                text: 'ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง กรุณาตรวจสอบใหม่อีกครั้ง',
                icon: 'warning',
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: `ตกลง`,
              }).then((result) => {
                if (result.isConfirmed) {
                  this.confirmError();
                }
              });
            } else if (status === 500) {
              Swal.fire({
                title: 'เกิดข้อผิดพลาด',
                text: 'เกิดข้อผิดพลาดจากเซิร์ฟเวอร์ กรุณาตรวจสอบใหม่อีกครั้ง',
                icon: 'error',
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: `ตกลง`,
              }).then((result) => {
                if (result.isConfirmed) {
                  this.confirmError();
                }
              });
            } else {
              Swal.fire({
                title: 'เกิดข้อผิดพลาด',
                text: message,
                icon: 'warning',
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: `ตกลง`,
              }).then((result) => {
                if (result.isConfirmed) {
                  this.confirmError();
                }
              });
            }
          } else if (error.request) {
            // Network error หรือ timeout
            Swal.fire({
              title: 'ไม่สามารถเชื่อมต่อได้',
              text: 'ไม่สามารถเชื่อมต่อกับเซิร์ฟเวอร์ได้ กรุณาตรวจสอบการเชื่อมต่ออินเทอร์เน็ต',
              icon: 'error',
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: `ตกลง`,
            }).then((result) => {
              if (result.isConfirmed) {
                this.confirmError();
              }
            });
          } else {
            // Error อื่นๆ
            Swal.fire({
              title: 'เกิดข้อผิดพลาด',
              text: 'เกิดข้อผิดพลาดที่ไม่ทราบสาเหตุ กรุณาตรวจสอบใหม่อีกครั้ง',
              icon: 'error',
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: `ตกลง`,
            }).then((result) => {
              if (result.isConfirmed) {
                this.confirmError();
              }
            });
          }
        }
      }
    },

    // ฟังค์ชั่น get รายการสาขา
    get_check_branch(token) {
      const config = {headers: {"Authorization": `Bearer ${token}`}}
      HTTP_ARIN.get('/branch/detail', config)
      .then((res) => {
        if (res.data.successful === true){
          this.branch = res.data.brancList.map((obj) => {
            return { 
              id: obj.id,
              branch_name: obj.store_name,
              status: false
            }
          });
        }
      })
    },

    // ฟังค์ชั่น ถ้า error ค่าจะโดนเครียส์เป็นค่าว่าง
    confirmError() {
      // this.telephone = ''
      this.password = ''
    },

    // ฟังค์ชั่น เข้าหน้าด้านในระบบ
    checkLogIn() {
      if (this.$store.state.store_arin.access_token != null) {
        this.$router.push('/arin')
        Swal.fire({
          title: 'ยินดีต้อนรับเข้าสู่ระบบ',
          text: '',
          icon: 'success',
          showDenyButton: false,
          showCancelButton: false,
          confirmButtonText: `ตกลง`,
          denyButtonText: `ยกเลิก`,
        }).then((result) => {
          if (result.isConfirmed) {
            this.confirmError();
          }
        });
      }
    },

    isNumber: function (evt, number) {
      return isTelephone(evt, number)
    },
    isTaxNumber: function (evt, number) {
      return taxNumber(evt, number)
    },
    isEmail: function (evt) {
      return validateEmail(evt)
    },
    isPaste: function (evt) {
      return onPaste(evt)
    },
  },
  mounted() {
    this.checkLogIn()
  },
  watch: {
    telephone() {
      this.checkSpace(this.telephone)
    }
  },
}
</script>

<style scoped>
.login_page {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  height: 100%;
  width: 100%;
  display: flex;
  /* grid-template-columns: 10% 35% 55%; */
  justify-content: center;
  align-items: center;
  background-image: url('~@/assets/arin_assets/bg.png');
  background-size: cover;
}

.v-list .v-list-item {
  border: 1px solid #D6BFAF;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 15px;
  margin-bottom: 10px;
}

.v-list .v-list-item--active {
  background-color: #D6BFAF !important;
  border-radius: 15px;
  box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.25);
}

.v-list .v-list-item--active .v-list-item__title {
  color: #FFFFFF !important;
  border-radius: 15px;
}

.v-list .v-list-item__title {
  font-weight: 600;
}

.v-list .v-list-item .v-list-item__content {
  padding-left: 10px;
}

.v-list .v-list-item .v-icon {
  color: #B0886B;
}

.logo_branch {
  width: 25px;
  margin: auto;
}

.logo_branch>img {
  max-width: 25px;
}

.choice_branch {
  display: flex;
  justify-content: space-between;
}

.text_style_color {
  color: #B0886B
}

.btn_custom {
  text-align: center;
}

.btn_next_close {
    background-color: #d2d2d2 !important;
    margin-right: 13px !important;
    border-radius: 10px !important;
    color: #fff !important;
    box-shadow: none !important;
    width: 100%;
    height: 44px !important;
}


</style>